export default {
  title: 'Dashboard Overview',
  projectExpVsBudget: {
    title: 'Expenditure vs Budget by Project',
    expenditure: 'Expenditure',
    variation: 'Variation orders',
    balance: 'Balance',
    budget: 'Budget',
    vos: 'VOs',
    noBudget: 'No BOQ budget available',
    empty: 'No project data currently available',
  },
  financialYearEnd: 'Financial year end is set to {date}.',
  change: 'Change',
  revenueData: {
    actualRevenueYearToDate: 'Actual Revenue - Year to date',
    actualExpenditureYearToDate: 'Actual Expenditure - Year to date',
    projRevenueCurrentMonth: 'Projected Revenue - Current month',
    projExpenditureCurrentMonth: 'Projected Expenditure - Current month',
    currentExpenditure: 'Current Expenditure - Live sites',
    availableBudget: 'Available Budget - Live sites',
    expensesVsAvailable: {
      title: 'Current Expenditure vs Available Budget - Live Projects',
      content: 'of {number} available',
    },
    barChart: {
      title: '12 month Income vs Expense',
      income: 'Income',
      spend: 'Spend',
      tooltip: {
        income: 'Income',
        expenses: 'Expenses',
        projectedIncome: 'Projected Income',
        projectedExpenses: 'Projected Expenses',
      },
    },
  },
  ordersData: {
    pending: 'Pending orders',
    awaitingDelivery: 'Orders awaiting delivery',
  },
  accountsData: {
    pendingPRs: 'Pending Payment Requests',
    pendingVariations: 'Pending VO Approvals',
  },
  siteStatusChart: {
    title: 'Site Status Overview',
    planning: 'Planning',
    live: 'Live',
    closed: 'Closed',
  },
  accountsOverview: {
    title: 'Accounts overview',
    subtitle: 'Account data are historical values',
    filters: {
      currentMonth: 'Current month',
      lastMonth: 'Last month',
      last3Months: 'Last 3 months',
    },
    table: {
      headers: {
        accounts: 'Accounts',
        projected: 'Projected',
        current: 'Current',
      },
      accountsPayable: 'Accounts payable',
      accountsReceivable: 'Accounts receivable',
      apPaid: 'AP Paid',
      cashflow: 'Cashflow',
      vat: 'VAT Liability',
    },
  },
  riskSummary: {
    title: 'Risks',
    table: {
      headers: {
        siteName: 'Site',
        projectName: 'Project',
        completionDate: 'Est. completion date',
        timelineUsed: 'Timeline used',
        budgetUsed: 'Budget used',
        budgetRemaining: 'Budget remaining',
      },
      view: 'View',
    },
    noData: 'There are currently no sites at risk',
  },
};
